import React from "react";
import SvgIcon from "@components/shared/icon/svgIcon/SvgIcon";
import s from "./FallbackComponent.module.scss";

interface FallbackProps {
  errorMessage?: string;
}

const FallbackComponent: React.FC<FallbackProps> = () => {
  const goHome = () => {
    window.location.href = "/";
  };

  return (
    <div className={s.fallbackBackground}>
      <div className={s.fallbackContainer}>
        <h2 className={s.title}>Что-то пошло не так</h2>
        <p className={s.subtitle}>
          Попробуйте обновить страницу <br /> или вернуться чуть позже.
        </p>

        <div className={s.iconCircle}>
          <SvgIcon name="icon-fallback" className={s.icon} sprite="sprite2"/>
        </div>

        <button className={s.homeButton} onClick={goHome}>
          Вернуться на главную
        </button>
      </div>
    </div>
  );
};

export default FallbackComponent;
